const getUrlParams = function () {
  const params = {}
  window.location.search.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
    params[key] = value
  })
  return params
}
const cmd = {
  service: 'sc-service',
  coupon: 'sc-coupon',
  localinfo: 'sc-local-info'
}
const func = {
  submit: 'set-submit',
  getcoupon: 'get-my-coupon',
  usecoupon: 'use-coupon',
  getlocalinfo: 'get-local-info'
}

const API = {
  ORIGIN_URL: process.env.VUE_APP_API_URL_ORGIN,
  // BASE_URL: process.env.VUE_APP_API_URL_WEB,
  // BF_URL: process.env.VUE_APP_API_URL_BF,
  BASE_URL: getUrlParams().debug && getUrlParams().debug === '1'
    ? process.env.VUE_APP_API_ORIGIN_DEBUG
    : process.env.VUE_APP_API_ORIGIN,
  ORDER_URL: getUrlParams().debug && getUrlParams().debug === '1'
    ? process.env.VUE_APP_ORDER_URL_DEV
    : process.env.VUE_APP_ORDER_URL,
  SITE_INFO: getUrlParams(),
  SUBMIT_PARAMS: {
    cmd: cmd.service,
    func: func.submit
  },
  GET_COUPON_PARAMS: {
    cmd: cmd.coupon,
    func: func.getcoupon,
    siteid: getUrlParams().site
  },
  USE_COUPON_PARAMS: {
    cmd: cmd.coupon,
    func: func.usecoupon
  },
  GET_LOCALINFO_PARAMS: {
    cmd: cmd.localinfo,
    func: func.getlocalinfo,
    siteid: getUrlParams().site
  }
}
export default API
